import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FormlyModule } from '@ngx-formly/core';
import { NgxMaskPipe } from 'ngx-mask';

import {
  AddressPipe,
  ButtonModule,
  ContextMenuModule,
} from '@lockton-apps/shared/ui/lui';
import { GetPipe, RejectPipe } from '@lockton-apps/shared/util/ng-lodash';

import { DynamicFormCardModule } from '../dynamic-form-card/dynamic-form-card.module';
import { DynamicFormCalcTableComponent } from './dynamic-form-calc-table.component';
import { FieldMetaPipe } from '../pipes/field-meta/field-meta.pipe';
import { DynamicFormCellModule } from '../dynamic-form-cell/dynamic-form-cell.module';
import { LetDirective } from '@ngrx/component';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [DynamicFormCalcTableComponent],
  imports: [
    CommonModule,
    FormlyModule,
    NgxMaskPipe,
    ButtonModule,
    MatIconModule,
    DynamicFormCardModule,
    AddressPipe,
    GetPipe,
    RejectPipe,
    FieldMetaPipe,
    DynamicFormCellModule,
    LetDirective,
    ContextMenuModule,
    MatMenuModule,
  ],
  exports: [DynamicFormCalcTableComponent],
})
export class DynamicFormCalcTableModule {}
